import { Autocomplete, Checkbox, Divider, ListItemText, MenuItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import { BtnOutlined, CmbWithTitle, Column, ContainerInside, ItemContainer, Items, LabelItem, ValueItem } from "../styled.components";


import FooterBtns from "../FooterBtns";
import { cloneObjectWithRegExp, hotToast, validateData } from "utils";
import Inputs, { InputsGroup } from "Components/Inputs";
import { InputModal, SelectMultiple } from "Components/V1/InputModal";
import IColumnas from "ITables/Columnas";
import Table from "Components/V1/Table";
import SaveIcon from "@mui/icons-material/Save";
import ServiceArchivo from "service/archivos";

//Character
const NAME_LIMIT = 100;
const CODE_LIMIT = 100;

const SCHEMADATA = {
    nombreArchivo: {
        error: false,
        required: true,
        type: "text",
        textError: "Ingresa un nombre valido",
        expresion: /^[a-zA-Z\u00F1\u00D1áéíóú\s0-9|&\-_.]+$/i,
    },
    prefijo: {
        error: false,
        required: true,
        type: "text",
        textError: "Ingresa un prefijo",
        expresion: /^[a-zA-Z\u00F1\u00D1áéíóú\s0-9|&\-_.]+$/i,
    },
    relatedFiles: {
        error: false,
        required: true,
        type: "multiSelect",
        textError: "Este campo es obligatorio",
        value: "",
    },
};

const EditArchivo = ({ reloadData, closeModal, loading, setLoading, row }: any) => {
    const [form, setForm] = React.useState<any>({
        nombreArchivo: "",
        relatedFiles: [],
        prefijo: '',
    });
    const [validate, setValidate] = useState(cloneObjectWithRegExp(SCHEMADATA));
    const [arrayColumnas, setArrayColumnas] = useState<Array<any>>([])
    const [arrayTipoDato, setArrayTipoDato] = useState<Array<any>>([])
    const [arrayReporteRelacion, setArrayReporteRelacion] = useState<Array<any>>([])
    const [columna, setColumna] = useState({
        nombreColumna: '',
        idTipoDato: '',
    });

    useEffect(() => {
        getAll();
    }, [row])

    const getAll = async () => {
        ServiceArchivo.cbmTipoDato({ setterFunc: setArrayTipoDato });
        ServiceArchivo.cbmReporteRelacion({ setterFunc: setArrayReporteRelacion })
        const data = await ServiceArchivo.get(() => { }, row.idArchivo)
        setForm({
            nombreArchivo: row.nombreArchivo,
            prefijo: row.prefijo,
            relatedFiles: data.archivosRelacionados.map((d: any) => ({ value: d.idVista, label: d.reporte }))
        })
        setArrayColumnas([...data.columnas])
    }


    const onSubmit = async () => {
        let flag = validateData({ validate, data: form }, setValidate);
        if (arrayColumnas.length === 0) { return hotToast("Ingresa por lo menos una columna", "WAR") }
        setLoading(true);
        if (!flag) {
            const request = {
                nombreArchivo: form.nombreArchivo,
                prefijo: form.prefijo,
                relatedFiles: form.relatedFiles.map((d: any) => d.value),
                columnas: arrayColumnas.map((d: any) => ({
                    orden: d.orden,
                    nombreColumna: d.nombreColumna,
                    idTipoColumna: d.idTipoColumna
                }))
            }
            let response = await ServiceArchivo.update(request, row.idArchivo);
            if (response) {
                hotToast("El registro se guardo correctamente", "SUCCESS");
                reloadData && reloadData();
                closeModal && closeModal();
                setValidate(SCHEMADATA);
            }
            setLoading(false);
        } else {
            setLoading(false);
        }
    };
    const handleChange = (e: any) => {
        let value = e.target.value;
        let name = e.target.getAttribute
            ? e.target.getAttribute("name")
            : e.target.name;
        setValidate({
            ...validate,
            [name]: {
                ...validate[name],
                error: false,
            },
        });
        setForm((old: any) => ({
            ...old,
            [name]: value,
        }));
    };
    const handleDelete = (item: any) => {
        setArrayColumnas((old: any) => {
            let arr = [...old];
            const index = arr.findIndex((d: any) => item.orden == d.orden);
            arr.splice(index, 1)
            return arr.map((d: any, index: number) => ({ ...d, orden: index + 1 }))
        });

    }
    const saveColumn = (e: any) => {
        if (columna.nombreColumna.trim() === '') { return hotToast("No has ingresado el nombre de la columna", "WAR") }
        if (columna.idTipoDato === '' || columna.idTipoDato === null) { return hotToast("No has ingresado el tipo de dato", "WAR") }
        if (arrayColumnas.some((item: any) => item.nombreColumna.trim().toLowerCase() === columna.nombreColumna.trim().toLowerCase())) { return hotToast("No se puede repetir el nombre de la columna", "WAR") }

        let items = [...arrayColumnas];
        items.push({
            orden: arrayColumnas.length + 1,
            nombreColumna: columna.nombreColumna,
            idTipoColumna: columna.idTipoDato,
            tipoColumna: arrayTipoDato.find((d: any) => columna.idTipoDato === d.value).label
        });
        setColumna({
            idTipoDato: '',
            nombreColumna: ''
        })
        setArrayColumnas([...items])
    }
    const handleAutoComplete = (newItem: any) => {
        let $form = { ...form };
        let $validate = { ...validate }
        if (newItem) {
            $form.relatedFiles = newItem;
        } else {
            $form.relatedFiles = []
        }
        $validate.relatedFiles.error = false;
        setForm($form);
        setValidate($validate)
    }



    return (
        <ContainerInside>
            <InputsGroup jC="space-around">
                <ItemContainer>
                    <LabelItem>Nombre del archivo:</LabelItem>
                    <ValueItem>{form.nombreArchivo}</ValueItem>
                </ItemContainer>
                <ItemContainer>
                    <LabelItem>Prefijo:</LabelItem>
                    <ValueItem>{form.prefijo}</ValueItem>
                </ItemContainer>
            </InputsGroup>
            <InputsGroup>
                <CmbWithTitle fullWidth aI={"center"}>
                    <span>Reportes relacionados</span>
                    <Autocomplete
                        multiple
                        fullWidth
                        id="tags-outlined"
                        limitTags={4}
                        options={arrayReporteRelacion}
                        value={form.relatedFiles}
                        getOptionLabel={(option) => option.label}
                        onChange={(event, newValue) => handleAutoComplete(newValue)}
                        filterSelectedOptions
                        renderInput={(params) => (
                            <InputModal
                                {...params}
                                fullWidth
                                error={validate.relatedFiles.error}
                                helperText={
                                    validate.relatedFiles.error && validate.relatedFiles.textError
                                }
                            />
                        )}
                    />
                </CmbWithTitle>





            </InputsGroup>
            <Divider />
            <Items>
                <Column ai={"flex-end"}>
                    <CmbWithTitle>
                        <span>Nombre de columna</span>
                        <InputModal
                            name="nombreColumna"
                            id="slcNombreColumna"
                            minWidth={'300px'}
                            onChange={(e: any) => setColumna((old: any) => ({ ...old, nombreColumna: e.target.value }))}
                            inputProps={{ maxLength: 250 }}
                            helperText={
                                `${columna.nombreColumna.length}/250`
                            }
                            value={columna.nombreColumna}
                        />
                    </CmbWithTitle>
                    <CmbWithTitle>
                        <span>Tipo de Dato</span>
                        <InputModal
                            name="tipoDato"
                            id="slcTipoDato"
                            select
                            minWidth={'300px'}
                            onChange={(e: any) => setColumna((old: any) => ({ ...old, idTipoDato: e.target.value }))}
                            value={columna.idTipoDato}
                        >
                            {arrayTipoDato &&
                                arrayTipoDato.map((item, index) => {
                                    return (
                                        <MenuItem key={index} value={item.value}>
                                            {item.label}
                                        </MenuItem>
                                    );
                                })}
                        </InputModal>
                    </CmbWithTitle>
                    <BtnOutlined
                        variant="outlined"
                        startIcon={<SaveIcon />}
                        onClick={saveColumn}
                    >
                        Guardar
                    </BtnOutlined>
                </Column>
                <Column jc={"flex-start"} mh="40vh" style={{ overflow: 'auto' }}>
                    <Table
                        IColumns={IColumnas({
                            handleDelete
                        })}
                        IData={arrayColumnas}
                        simply
                    />
                </Column>
            </Items>

            <FooterBtns
                handleCancel={closeModal}
                handleSubmit={onSubmit}
                loader={loading}
            />
        </ContainerInside >
    );
};

export default EditArchivo;
